import {
    Button,
    CircularProgress,
    IconButton,
    InputAdornment,
    TextField,
    Typography
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import styles from '../styles.module.css';
import useLogin, { HELPERTEXT } from '../hook/useLogin';
import AlertComponent from '../../../components/AlertMessage/AlertMessage';
import { useEffect, useState } from 'react';
import { sharedLoginTextFieldSx } from '../styles';

const UserConfirmation = () => {
    const { t } = useTranslation('userForm');
    const navigate = useNavigate();

    const {
        usuario,
        setUsuario,
        verificationCode,
        handleShowPassword,
        setVerificationCode,
        showPassword,
        newPassword,
        setNewPassword,
        error,
        handleConfirmUser,
        loading
    } = useLogin();

    const [isButtonDisabled, setIsButtonDisabled] = useState(true);

    useEffect(() => {
        setIsButtonDisabled(
            !usuario || !verificationCode || !newPassword.password1 || !newPassword.password2
        );
    }, [usuario, verificationCode, newPassword]);

    const primaryButtonSx = {
        backgroundColor: '#3BD2D2',
        color: '#131B20',
        fontWeight: 700,
        '&:hover': {
            backgroundColor: '#30C2C2'
        },
        '&.Mui-disabled': {
            backgroundColor: '#AFC7CC',
            color: '#5D6A72'
        }
    };

    const helperTextSx = {
        '& .MuiFormHelperText-root': {
            color: '#6F7A81',
            marginLeft: 0,
            marginRight: 0,
            marginTop: '4px',
            marginBottom: 0
        }
    };

    return (
        <>
            <Typography className={styles.loginFlowTitle}>
                {t('activateUserTitle')}
            </Typography>
            <TextField
                required
                name="user"
                className={styles.formElement}
                label={t('user')}
                value={usuario || ''}
                onChange={(e) => setUsuario(e.target.value)}
                variant="outlined"
                error={!!error}
                sx={{
                    ...sharedLoginTextFieldSx,
                    ...helperTextSx
                }}
            />
            <TextField
                required
                name="verificationCode"
                className={styles.formElement}
                label={t('verificationCode')}
                type="text"
                value={verificationCode || ''}
                onChange={(e) => setVerificationCode(e.target.value)}
                variant="outlined"
                error={!!error}
                sx={{
                    ...sharedLoginTextFieldSx,
                    ...helperTextSx
                }}
            />
            <TextField
                required
                name="password"
                className={styles.formElement}
                id="filled-required"
                label={t('password')}
                type={showPassword.password ? 'text' : 'password'}
                value={newPassword?.password1 || ''}
                onChange={(e) => setNewPassword({ ...newPassword, password1: e.target.value })}
                variant="outlined"
                error={!!error}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                aria-label="toggle password visibility"
                                onClick={() => handleShowPassword('password')}
                                edge="end"
                            >
                                {showPassword.password ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                        </InputAdornment>
                    )
                }}
                helperText={!error && HELPERTEXT}
                sx={{
                    ...sharedLoginTextFieldSx,
                    ...helperTextSx
                }}
            />
            <TextField
                required
                name="passwordConfirm"
                className={styles.formElement}
                label={t('passwordConfirm')}
                type={showPassword.passwordConfirm ? 'text' : 'password'}
                value={newPassword?.password2 || ''}
                onChange={(e) => setNewPassword({ ...newPassword, password2: e.target.value })}
                variant="outlined"
                error={!!error}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                aria-label="toggle password visibility"
                                onClick={() => handleShowPassword('passwordConfirm')}
                                edge="end"
                            >
                                {showPassword.passwordConfirm ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                        </InputAdornment>
                    )
                }}
                sx={{
                    ...sharedLoginTextFieldSx,
                    ...helperTextSx
                }}
            />
            <Button
                className={styles.btnSubmit}
                variant="contained"
                onClick={handleConfirmUser}
                disabled={isButtonDisabled}
                sx={primaryButtonSx}
            >
                {t('activateUser')}
                {loading && (
                    <CircularProgress style={{ margin: '0 10px' }} color="inherit" size="1.5em" />
                )}
            </Button>
            <div className={styles.btnTextContainer}>
                <Button className={styles.btnText} variant="text" onClick={() => navigate('/login')}>
                    {t('goBack')}
                </Button>
            </div>
            {error && (
                <AlertComponent message={error} severity="error" style={{ marginTop: '16px' }} />
            )}
        </>
    );
};

export default UserConfirmation;
